import React from 'react'

export const SwatchUsersGeneralTitle = () => {
	return (
		<div className='swatch_user_top_left'>
			<span>Sistema Usuarios Swatch</span>
		</div>
	)
}
